'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { User } from './User';
import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class UserVoipPhoneNumber extends Entity {
  protected id;
  protected user;
  protected provider;
  protected app;
  protected phoneNumber;
  protected phoneNumberName;
  protected extension;
  protected phoneNumberId;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.phoneNumber = data.phoneNumber;
    this.phoneNumberName = data.phoneNumberName;
    this.extension = data.extension;
    this.phoneNumberId = data.phoneNumberId;

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }

    if (data.provider) {
      const provider = new UserIntegrationProvider();

      provider.hydrate(data.provider);

      this.provider = provider;
    }

    if (data.app) {
      const app = new App();

      app.hydrate(data.app);

      this.app = app;
    }
  }

  public getId() {
    return this.id;
  }

  public getPhoneNumber() {
    return this.phoneNumber;
  }

  public getPhoneNumberName() {
    return this.phoneNumberName;
  }

  public getExtension() {
    return this.extension;
  }

  public getPhoneNumberId() {
    return this.phoneNumberId;
  }
}
